import {
  nodeAtomFamily,
  isZapNode,
  DefaultNodeData,
  ZapNodeData,
  floatingToolbarActiveButtonAtom,
  determineAssetType,
  NodeType,
} from "@zapier/canvas-state";
import { useAtomValue } from "jotai";
import { Node } from "@xyflow/react";

import { Sidebar } from "../Sidebar";
import { StepTitleField } from "../StepTitleField";
import { Notes } from "../Notes";

import { useSidebarEventHandlers } from "./useSidebarEventHandlers";
import { ZapPreviewContainer } from "./ZapPreviewContainer";
import { ActorTypeahead } from "./ActorTypeahead";
import styles from "./NodeSidebar.module.css";
import { EditAssetButton } from "./EditAssetButton";
import { ActorList } from "./ActorList";
import { SidebarColorPicker } from "./SidebarColorPicker";

export function NodeSidebar({ id }: { id: string }) {
  const singleSelectedNode = useAtomValue(nodeAtomFamily(id)) as Node<
    DefaultNodeData | ZapNodeData
  >;
  const zapId = isZapNode(singleSelectedNode)
    ? singleSelectedNode?.data.zapId
    : undefined;
  const activeFloatingToolbarButton = useAtomValue(
    floatingToolbarActiveButtonAtom,
  );

  const { onDeleteStep, onRemoveZap } = useSidebarEventHandlers({
    node: singleSelectedNode,
  });

  const assetType = determineAssetType(
    (singleSelectedNode.data as DefaultNodeData).services,
    singleSelectedNode.type as NodeType,
  );

  return (
    <Sidebar heading="Step details" onDeleteStep={onDeleteStep}>
      <div className={styles.sidebarWrapper}>
        {assetType !== "agent" && (
          <StepTitleField
            label={singleSelectedNode?.data.label}
            id={id}
            assetType={assetType}
          />
        )}
        {zapId && (
          <ZapPreviewContainer onRemoveZap={onRemoveZap} zapId={zapId} />
        )}
        <EditAssetButton nodeId={id} />
        <SidebarColorPicker node={singleSelectedNode} />
        <span>
          <ActorTypeahead id={id} />
          <ActorList nodeId={id} actors={singleSelectedNode.data.actors} />
        </span>
        <span>
          <Notes
            nodeId={singleSelectedNode.id}
            notesJson={singleSelectedNode.data.notesJson}
            shouldFocus={activeFloatingToolbarButton === "note"}
          />
        </span>
      </div>
    </Sidebar>
  );
}
